import UIIcon from "../UIIcon";
import styles from "./NextPrevButton.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

export type NextPrevButtonProps = {
    direction: "Left" | "Right";
    id: string;
    disabled?: true;
    ariaLabelText?: string;
    className?: string;
    marginAuto?: boolean;
};

export const NextPrevButton = ({
    direction,
    id,
    disabled,
    ariaLabelText,
    className,
}: NextPrevButtonProps) => {
    return (
        <button
            className={cx("nextPrevButton", "navButton", className)}
            id={id}
            disabled={disabled}
            aria-label={ariaLabelText}
        >
            <UIIcon icon={`Chevron${direction}`} className={cx("icon")} />
        </button>
    );
};
